import { Inertia } from '@inertiajs/inertia';
import store from '@/store';

// Vuex module: State, Getters, Mutations, Actions
const state = {
    toast: {
        title: '',
        description: '',
        type: 'success', // can be 'success', 'error', 'warning', 'info'
        timeout: 3000 // default timeout
    },
    show: false
};

// Getters
const getters = {
    toast: state => state.toast,
    show: state => state.show
};

// Mutations
const mutations = {
    SET_TOAST(state, payload) {
        state.toast = payload;
    },
    SET_SHOW(state, payload) {
        state.show = payload;
    }
};

// Actions
const actions = {
    showToast({ commit, dispatch }, { title, description = '', type = 'success', options = {} }) {
        commit('SET_TOAST', {
            title,
            description,
            type,
            timeout: options.timeout || 3000
        });
        commit('SET_SHOW', true);

        // Auto hide after timeout
        setTimeout(() => {
            dispatch('hideToast');
        }, options.timeout || 3000);
    },

    hideToast({ commit }) {
        commit('SET_SHOW', false);
    },

    success({ dispatch }, { title, description = '', options = {} }) {
        dispatch('showToast', { title, description, type: 'success', options });
    },

    error({ dispatch }, { title, description = '', options = {} }) {
        dispatch('showToast', { title, description, type: 'error', options });
    },

    warning({ dispatch }, { title, description = '', options = {} }) {
        dispatch('showToast', { title, description, type: 'warning', options });
    },

    info({ dispatch }, { title, description = '', options = {} }) {
        dispatch('showToast', { title, description, type: 'info', options });
    }
};

Inertia.on('success', (event) => {
    const toastData = event.detail?.page?.props?.toast;
    if (toastData) {
        const { title, message, type } = toastData;
        switch (type) {
            case 'error':
                store.dispatch('toast/error', { title, description: message });
                break;
            case 'warning':
                store.dispatch('toast/warning', { title, description: message });
                break;
            case 'info':
                store.dispatch('toast/info', { title, description: message });
                break;
            default:
                store.dispatch('toast/success', { title, description: message });
                break;
        }
    }
});

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};